<template>
  <b-modal
    ref="bModal"
    modal-class="modalMoreInfo"
    style="z-index:0"
    :title="$t('laboratory.tracking.moreInfo')"
    hide-backdrop
    :no-close-on-backdrop="false"
    no-fade
    hide-footer
    @hide="onHide"
  >
    <!--Portion Data-->
    <b-row>
      <b-col class="form-box">
        <div class="structure">
          <span
            v-if="isPortion && information"
            class="structure__heading d-flex"
            qa="modal-more-info-portion-label"
          >
            <i
              class="mr-1"
              :class="portionTypes[information.portionType.portionTypeEnum].icon"
              aria-hidden="true"
            />
            {{ information && information.portionLabel }}
            <b-badge
              v-if="getCaseOfReference"
              v-tooltip="$t('registry.btn.consultation')"
              pill
              class="ml-1 icon-badge indicator-bubble d-flex align-items-center justify-content-center"
            >
              <i
                class="far fa-glasses"
                aria-hidden="true"
              />
            </b-badge>
          </span>
          <span
            v-else
            class="structure__heading d-flex"
            qa="modal-more-info-subportion-label"
          >
            <i
              class="icon-porta mr-2"
              aria-hidden="true"
            />
            {{ information && information.subportionLabel }}
            <!-- TODO: Pendiente caso consulta -->
            <b-badge
              v-if="getCaseOfReference"
              v-tooltip="$t('registry.btn.consultation')"
              pill
              class="ml-1 icon-badge indicator-bubble d-flex align-items-center justify-content-center"
            >
              <i
                class="far fa-glasses"
                aria-hidden="true"
              />
            </b-badge>
          </span>
          <b-row v-if="isPortion">
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $t('component.samplesModal.type') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-sample-type"
                >
                  {{ information ? information.sample.sampleType.description : '' }}
                </h4>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $t('laboratory.content.portionType') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-portion-type"
                >
                  {{ information ? information.portionType.potName : '' }}
                </h4>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $t('laboratory.tracking.resident') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-resident"
                >
                  {{ information && information.sample.caseStudy.resident ? information.sample.caseStudy.resident.fullName : '' }}
                </h4>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $t('laboratory.content.markedAsDepleted') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-marked-as-depleted"
                >
                  {{ information && information.depleted ? $t('global.yes') : $t('global.no') }}
                </h4>
              </div>
            </b-col>
            <b-col
              cols="12"
              class="mt-3"
            >
              <span class="ap-title ap-title__section">{{ $tc('laboratory.sidebar.processes') }}</span>
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $t('component.samplesModal.dateSample') }}</small>
                <h4
                  v-if="information && information.sample.lastGrossingDate"
                  class="collapsable-card-title inside"
                  qa="modal-more-info-grossing-date"
                >
                  {{ (information.sample.lastGrossingDate ? information.sample.lastGrossingDate : '-') | datetime }}
                </h4>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $tc('component.samplesModal.grossingResponsible') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-grossing-responsible"
                >
                  {{ information && information.sample.responsibleForLastGrossing ? information.sample.responsibleForLastGrossing.fullName : '' }}
                </h4>
              </div>
            </b-col>
            <b-col cols="12">
              <hr class="my-2">
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $t('laboratory.grid.processingStartDate') }}</small>
                <h4
                  v-if="information && information.processingStartDate"
                  class="collapsable-card-title inside"
                  qa="modal-more-info-processing-start-date"
                >
                  {{ (information.processingStartDate ? information.processingStartDate : '-') | datetime }}
                </h4>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $t('laboratory.grid.processingStartPersonnel') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-processing-start-personnel"
                >
                  {{ information && information.processingStartPersonnel ? information.processingStartPersonnel.fullName : '-' }}
                </h4>
              </div>
            </b-col>
            <b-col cols="12">
              <hr class="my-2">
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $t('laboratory.grid.processingEndDate') }}</small>
                <h4
                  v-if="information && information.processingEndDate"
                  class="collapsable-card-title inside"
                  qa="modal-more-info-processing-end-date"
                >
                  {{ (information.processingEndDate ? information.processingEndDate : '-') | datetime }}
                </h4>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $t('laboratory.grid.processingEndPersonnel') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-processing-end-personnel"
                >
                  {{ information && information.processingEndPersonnel ? information.processingEndPersonnel.fullName : '-' }}
                </h4>
              </div>
            </b-col>
            <b-col cols="12">
              <hr class="my-2">
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $t('laboratory.grid.confectionDate') }}</small>
                <h4
                  v-if="information && information.generationDate"
                  class="collapsable-card-title inside"
                  qa="modal-more-info-processing-generation-date"
                >
                  {{ (information.generationDate ? information.generationDate : '-') | datetime }}
                </h4>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $t('laboratory.grid.confectionTech') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-processing-generation-personnel"
                >
                  {{ information && information.generationResponsiblePersonnel ? information.generationResponsiblePersonnel.fullName : '-' }}
                </h4>
              </div>
            </b-col>
            <b-col cols="12">
              <hr class="my-2">
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $t('laboratory.grid.lastSubportionCutDate') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-processing-cut-date"
                >
                  {{ (information && information.lastSubportionCutDate ? information.lastSubportionCutDate : '-') | datetime }}
                </h4>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $t('laboratory.grid.lastSubportionCutter') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-processing-cut-personnel"
                >
                  {{ information && information.lastSubportionCutter ? information.lastSubportionCutter.fullName : '-' }}
                </h4>
              </div>
            </b-col>
          </b-row>
          <!--Subportion Data-->
          <b-row v-if="!isPortion">
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $t('component.samplesModal.type') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-sample-type"
                >
                  {{ information && information.portion ? information.portion.sample.sampleType.description : '' }}
                </h4>
              </div>
            </b-col>
            <b-col
              v-if="!isVirtualPortionType"
              cols="6"
            >
              <div class="structure__data">
                <small>{{ $t('laboratory.content.portionType') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-portion-type"
                >
                  {{ information && information.portion ? information.portion.portionType.potName : '' }}
                </h4>
              </div>
            </b-col>
            <b-col
              cols="12"
              class="mt-3"
            >
              <span class="main">{{ $tc('laboratory.sidebar.processes') }}</span>
            </b-col>
            <template v-if="!isVirtualPortionType">
              <b-col cols="6">
                <div class="structure__data">
                  <small>{{ $tc('laboratory.grid.confectionDate') }}</small>
                  <h4
                    v-if="information && information.portion && information.portion.generationDate"
                    class="collapsable-card-title inside"
                    qa="modal-more-info-generation-date"
                  >
                    {{ (information.portion.generationDate ? information.portion.generationDate : '-') | datetime }}
                  </h4>
                </div>
              </b-col>
              <b-col cols="6">
                <div class="structure__data">
                  <small>{{ $tc('laboratory.grid.confectionTech') }}</small>
                  <h4
                    class="collapsable-card-title inside"
                    qa="modal-more-info-generation-personnel"
                  >
                    {{ information && information.portion && information.portion.generationResponsiblePersonnel ? information.portion.generationResponsiblePersonnel.fullName : '-' }}
                  </h4>
                </div>
              </b-col>
              <b-col cols="12">
                <hr class="my-2">
              </b-col>
              <b-col cols="6">
                <div class="structure__data">
                  <small>{{ $t('component.incidentModal.cutDate') }}</small>
                  <h4
                    v-if="information && information.cutDate"
                    class="collapsable-card-title inside"
                    qa="modal-more-info-cut-date"
                  >
                    {{ (information.cutDate ? information.cutDate : '-') | datetime }}
                  </h4>
                </div>
              </b-col>
              <b-col cols="6">
                <div class="structure__data">
                  <small>{{ $tc('laboratory.grid.cutTech') }}</small>
                  <h4
                    class="collapsable-card-title inside"
                    qa="modal-more-info-cut-personnel"
                  >
                    {{ information && information.cutterPersonnel ? information.cutterPersonnel.fullName : '-' }}
                  </h4>
                </div>
              </b-col>
              <b-col cols="12">
                <hr class="my-2">
              </b-col>
            </template>
            <b-col cols="3">
              <div class="structure__data">
                <small>{{ $tc('laboratory.grid.stainingEntryDate') }}</small>
                <h4
                  v-if="information && information.assayStartDate"
                  class="collapsable-card-title inside"
                  qa="modal-more-info-assay-start-date"
                >
                  {{ (information.assayStartDate ? information.assayStartDate : '-') | datetime }}
                </h4>
              </div>
            </b-col>
            <b-col cols="3">
              <div class="structure__data">
                <small>{{ $tc('global.instrument', 1) }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-assay-device"
                >
                  {{ information && information.assayDevice ? information.assayDevice.device : '-' }}
                </h4>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="structure__data">
                <small>{{ $tc('laboratory.grid.stainingEntryTechnician') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-assay-start-personnel"
                >
                  {{ information && information.assayStartResponsiblePersonnel ? information.assayStartResponsiblePersonnel.fullName : '-' }}
                </h4>
              </div>
            </b-col>
            <b-col cols="12">
              <hr class="my-2">
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $tc('laboratory.grid.stainingDepartureDate') }}</small>
                <h4
                  v-if="information && information.assayEndDate"
                  class="collapsable-card-title inside"
                  qa="modal-more-info-assay-end-date"
                >
                  {{ (information.assayEndDate ? information.assayEndDate : '-') | datetime }}
                </h4>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $tc('laboratory.grid.stainingDepartureTechnician') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-assay-end-personnel"
                >
                  {{ information && information.assayEndResponsiblePersonnel ? information.assayEndResponsiblePersonnel.fullName : '-' }}
                </h4>
              </div>
            </b-col>
            <b-col cols="12">
              <hr class="my-2">
            </b-col>
            <b-col cols="3">
              <div class="structure__data">
                <small>{{ $tc('laboratory.grid.scannerEntryDate') }}</small>
                <h4
                  v-if="information && information.scanStartDate"
                  class="collapsable-card-title inside"
                  qa="modal-more-info-scan-start-date"
                >
                  {{ (information.scanStartDate ? information.scanStartDate : '-') | datetime }}
                </h4>
              </div>
            </b-col>
            <b-col cols="3">
              <div class="structure__data">
                <small>{{ $tc('global.instrument', 1) }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-scan-device"
                >
                  {{ information && information.scannerDevice ? information.scannerDevice.device : '-' }}
                </h4>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="structure__data">
                <small>{{ $tc('laboratory.grid.scannerEntryTechnician') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-scan-start-personnel"
                >
                  {{ information && information.scanStartResponsiblePersonnel ? information.scanStartResponsiblePersonnel.fullName : '-' }}
                </h4>
              </div>
            </b-col>
            <b-col cols="12">
              <hr class="my-2">
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $tc('laboratory.grid.scannerDepartureDate') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-scan-end-date"
                >
                  {{ (information && information.scanEndDate ? information.scanEndDate : '-') | datetime }}
                </h4>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="structure__data">
                <small>{{ $tc('laboratory.grid.scannerDepartureTechnician') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="modal-more-info-scan-end-personnel"
                >
                  {{ information && information.scanEndResponsiblePersonnel ? information.scanEndResponsiblePersonnel.fullName : '-' }}
                </h4>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <!--Observations-->
    <b-row>
      <b-col class="form-box">
        <div class="structure pt-2 pl-4 pr-4 pb-2">
          <span class="ap-title ap-title__section">
            <i
              class="fal fa-comment-lines mr-2"
              aria-hidden="true"
            />
            {{ $t('global.observations') }}
          </span>

          <b-row>
            <b-col>
              <h4 qa="modal-more-info-observations">
                {{ information && information.notes ? information && information.notes : '-' }}
              </h4>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import portionServices from '@/api/resources/common/commonPortionServices'
import subportionServices from '@/api/resources/common/commonSubportionServices'
import { PORTION_TYPES } from '@/api/resources/portionTypeService'

export default {
    name: 'ModalMoreInfo',
    components: { },
    data() {
        return {
            isPortion: false,
            selected: null,
            information: null,
            portionTypes: PORTION_TYPES,
            options: [
                { value: null, text: '' },
                { value: 'a', text: 'Opción 1' },
                { value: 'b', text: 'Opción 2' },
                { value: 'b', text: 'Opción 3' }
            ]
        }
    },
    computed: {
        labId() {
            return this.$store.getters.labId
        },
        isVirtualPortionType() {
            let isVirtualPortion = null
            if (this.isPortion) {
                isVirtualPortion = this.information?.portionType.portionTypeEnum === PORTION_TYPES.VIRTUAL.key
            } else {
                isVirtualPortion = this.information?.portion.portionType.portionTypeEnum === PORTION_TYPES.VIRTUAL.key
            }
            return isVirtualPortion
        },
        getCaseOfReference() {
            if (this.information) {
                if (this.isPortion) {
                    return this.information.sample.caseStudy.caseOfReference
                }
                return this.information.portion.sample.caseStudy.caseOfReference
            }
            return false
        }
    },
    methods: {
        onHide() {
            this.information = null
        },
        show(isPortion) {
            this.isPortion = isPortion
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        async loadPortionInformation(data) {
            this.information = null
            const [err, response] = await this.toCall(portionServices.getPortionInformation(this.labId, data.sample.caseStudy.casId, data.sample.samId, data.porId))
            if (err) {
                this.showErrorModalGlobal()
                this.closeAdditionalSidepanel()
                return
            }
            this.information = response
        },
        async loadSubportionInformation(data) {
            this.information = null
            const [err, response] = await this.toCall(subportionServices.getSubportionInformation(this.labId, data.portion.sample.caseStudy.casId, data.portion.sample.samId, data.portion.porId, data.supId))
            if (err) {
                this.showErrorModalGlobal()
                this.closeAdditionalSidepanel()
                return
            }
            this.information = response
        }
    }
}
</script>

<style lang="scss">

.modalMoreInfo .modal-dialog{
    max-width: 50% !important;
    margin: 0;
    position: absolute;
    right: 0;
}

.modalMoreInfo .modal-body{
    padding: 0.6rem 1.1rem 0 1.1rem !important;
}

.modalMoreInfo .modal-content{
  top: 50px;
  height: calc(100vh - 83px);
  border-radius: 0;
  box-shadow: -3px 0px 10px 2px #8f8f8f !important;
}

</style>

<style scoped>

.modalMoreInfo {
    color: #303133;
}

.modalMoreInfo h4{
  font-weight: normal;
}

</style>
